import React from 'react';

import { Link } from 'gatsby';
import { sortingOptions } from './static-values';

import slugify from 'slugify';

import '../../../styles/shop/print-sorting-options.scss';

const buildLinkPath = (filterAttribute, filterValue, sortSlug) => {
  let path = '/shop/fine-art-prints';

  path += filterAttribute ? `/${slugify(filterAttribute).toLowerCase()}` : '';
  path += filterValue ? `/${slugify(filterValue).toLowerCase()}` : '';

  path += `/${sortSlug}`;

  return path;
}

const PrintSortingOptions = (props) => {
  return (
    <div className="print-sorting-options">
      <div className="print-sorting-options__column">
        <p className="print-sorting-options__header">
          Sort by Artist
        </p>
        <ul>
          <li>
            <Link to={ buildLinkPath( props.filterAttribute, props.filterValue, 'artist-a-to-z') }>
              { sortingOptions['artist-a-to-z'] }
            </Link>
          </li>
          <li>
            <Link to={ buildLinkPath( props.filterAttribute, props.filterValue, 'artist-z-to-a') }>
              { sortingOptions['artist-z-to-a'] }
            </Link>
          </li>
        </ul>
      </div>
      <div className="print-sorting-options__column">
        <p className="print-sorting-options__header">
          Sort by Year
        </p>
        <ul>
          <li>
            <Link to={ buildLinkPath( props.filterAttribute, props.filterValue, 'oldest-to-newest') }>
              { sortingOptions['oldest-to-newest'] }
            </Link>
          </li>
          <li>
            <Link to={ buildLinkPath( props.filterAttribute, props.filterValue, 'newest-to-oldest') }>
              { sortingOptions['newest-to-oldest'] }
            </Link>
          </li>
        </ul>
      </div>
      <div className="print-sorting-options__column">
        <p className="print-sorting-options__header">
          Sort by Recency
        </p>
        <ul>
          <li>
            <Link to={ buildLinkPath( props.filterAttribute, props.filterValue, 'most-recent') }>
              { sortingOptions['most-recent'] }
            </Link>
          </li>
          <li>
            <Link to={ buildLinkPath( props.filterAttribute, props.filterValue, 'least-recent') }>
              { sortingOptions['least-recent'] }
            </Link>
          </li>
        </ul>
      </div>
      <div className="print-sorting-options__column">
        <p className="print-sorting-options__header">
          Sort by Popularity
        </p>
        <ul>
          <li>
            <Link to={ buildLinkPath( props.filterAttribute, props.filterValue, 'most-popular') }>
              { sortingOptions['most-popular'] }
            </Link>
          </li>
          <li>
            <Link to={ buildLinkPath( props.filterAttribute, props.filterValue, 'least-popular') }>
              { sortingOptions['least-popular'] }
            </Link>
          </li>
        </ul>
      </div>
      <div className="print-sorting-options__column">
        <p className="print-sorting-options__header">
          &nbsp;
        </p>
        <ul>
          <li>
            <Link to={ buildLinkPath( props.filterAttribute, props.filterValue, 'random' ) }>
              { sortingOptions['random'] }
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default PrintSortingOptions;